/*SYSTEM IMPORTS*/
import React from 'react'
import moment from 'moment'

import './style'
import './media'

/*Ui*/
import Cont from 'components/ui/Cont'
import AnswersSlider from 'components/ui/AnswersSliderV2'
import AnswerCardV2 from 'components/ui/AnswerCardV2'
import Avatar, { UserAvatar } from 'components/ui/Avatar'

import {Request} from "api"
import QuestionApi from "api/question"

import UserIcon from "svg/UserSvg"
import GlassesSvg from "svg/GlassesSvg"

/*CORES*/
import AppCore from 'cores/AppCore'

class ContAnswers extends React.PureComponent {
    state = { data: [] }

    componentDidMount(){
        const {value = {}} = this.props
        const { answers = [] } = value

        this.getData(answers)
    }

    getData = async (answers) => {
        const { user = {} } = this.props

        let data = []

        for (let i=0; i < answers.length; i++) {
            try {
                const { question } = await Request(QuestionApi.GetQuestionWithDoctorAnswer, {
                    doctor_id: user.id,
                    answer_id: parseInt(answers[i].answer_id)
                })

                data.push( question )
            } catch (e) {
                console.log(e)
            }
        }

        this.setState({
            data
        })
    }

    getAuthorAvatar = ( item ) => {
       if(item.anonymous == false )
       {
           if(item.author.id == 0)
           {
               return (
                   <Avatar image={<UserIcon />}>
                       <div className="name">
                           {item.author.name}
                       </div>
                   </Avatar>
               )

           } else {
               return (
                   <UserAvatar
                       {...item.author}
                   >
                       <div className="name">{item.author.full_name}</div>
                   </UserAvatar>
               )
           }
       } else {
           return (
               <Avatar image={<GlassesSvg/>}>
                   <div className="name">
                       { AppCore.Interfaces.t( "DoctorLanding.Ui.ContAnswersV2.Index.AvatarAnonymous" ) }
                   </div>
               </Avatar>
           )
       }
    }

    listToQuestions = (list) => {
        const sortedList = list.sort(sortByDate)

        return sortedList.map(item => ({
            id: item.id,
            link: `/question/${item.seo_alias}`,
            dateQuestion: moment(item.date_create, 'YYYY-MM-DD HH:mm:ss').fromNow(),
            question: item.title,
            description: item.description,
            answer: item.answer.comment,
            dateAnswer: moment(item.answer.date_create, 'YYYY-MM-DD HH:mm:ss').fromNow(),
            avatar: this.getAuthorAvatar( item ),
        }))
    }

    render() {
        const { id } = this.props

        const { data = [] } = this.state

        const questions = this.listToQuestions(data)

        return (
            <>
                {questions.length > 0 &&
                <Cont id={`block-${id}`} className="cont-answers">
                    <h2>
                        { AppCore.Interfaces.t( "DoctorLanding.Ui.ContAnswersV2.Index.Title" ) }
                    </h2>

                    <AnswersSlider
                        list={questions.map(item => (
                            <div className="item">
                                <AnswerCardV2 key={item.id} {...item} />
                            </div>
                        ))}
                    />
                </Cont>
                }
            </>

        )
    }
}

const sortByDate = (a,b) => {
    let moment_a = moment(a.answer.date_create, 'YYYY-MM-DD HH:mm:ss')
    let moment_b = moment(b.answer.date_create, 'YYYY-MM-DD HH:mm:ss')

    if(moment_a.isAfter(moment_b)){
        return -1
    } else if(moment_a.isSame(moment_b)){
        return 0
    } else if(moment_a.isBefore(moment_b)){
        return 1
    }
}

export default ContAnswers